import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EditUser from "../components/pages/EditUser";
import Dashboard from "../components/pages/Dashboard";
import Login from "../components/pages/Login";
import NewUser from "../components/pages/NewUser";
import Users from "../components/pages/Users";
import VerificationRequests from "../components/pages/VerificationRequests";
import AdminProfile from "../components/pages/admin/AdminProfile";
import ChangePassword from "../components/pages/admin/ChangePassword";
import NewCMSPage from "../components/pages/NewCMSPage";
import CMSPageList from "../components/pages/CMSPageList";
import DeletedUsers from "../components/pages/DeletedUsers";
import GeneralSetting from "../components/pages/GeneralSetting";
import FAQList from "../components/pages/faq/FAQList";
import AddFAQ from "../components/pages/faq/AddFAQ";
import EditFAQ from "../components/pages/faq/EditFAQ";
import ViewRequest from "../components/pages/ViewRequest";
import Themes from "../components/pages/themes";
import EditTheme from "../components/pages/EditTheme";
import AddTheme from "../components/pages/AddTheme";

const Router = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/admin">
          <Route index={true} element={<Login />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="new-user" element={<NewUser />} />
          <Route path="edit-user/:userId" element={<EditUser />} />
          <Route
            path="verification-requests"
            element={<VerificationRequests />}
          />
          <Route path="request/:id" element={<ViewRequest />} />
          <Route path="admin-profile" element={<AdminProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="cms/:id" element={<NewCMSPage />} />
          <Route path="cms-pages" element={<CMSPageList />} />
          <Route path="deleted-users" element={<DeletedUsers />} />
          <Route path="general-settings" element={<GeneralSetting />} />
          <Route path="faqs" element={<FAQList />} />
          <Route path="add-faq" element={<AddFAQ />} />
          <Route path="edit-faq/:oldId" element={<EditFAQ />} />
          <Route path="themes" element={<Themes />} />
          <Route path="edit-theme/:id" element={<EditTheme />} />
          <Route path="add-theme" element={<AddTheme />} />
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Router;
